import { render, staticRenderFns } from "./actlist.html?vue&type=template&id=31d1e5db&scoped=true&"
import script from "./actlist.js?vue&type=script&lang=js&"
export * from "./actlist.js?vue&type=script&lang=js&"
import style0 from "./actlist.sass?vue&type=style&index=0&id=31d1e5db&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1e5db",
  null
  
)

component.options.__file = "actlist.vue"
export default component.exports